/* eslint-disable @typescript-eslint/explicit-function-return-type */
const getInitialValue = () => {
    return {
        starting: true,
        data: {},
        queryStarted: false,
        span: {},
        endHistory: false,
        buffer: {}
    }
}

const WidgetReducer = (state = getInitialValue(), message) => {
    // if (message?.layer === 0 && message?.type === 'event') {
    //     console.log('message', message)
    // }

    switch (message?.type) {
        case 'start':
            return { ...state, data: {}, starting: true, queryStarted: true }
        case 'event': {
            state.buffer = {
                ...state.buffer,
                [message?.layer]: message?.events
            }

            const hasData = state.data[message?.layer]?.length > 0

            if (!hasData && message?.events?.length > 0) {
                return {
                    ...state,
                    data: {
                        ...state.data,
                        [message?.layer]: message?.events
                    }
                }
            }

            if (!hasData && message?.events?.length === 0) {
                return {
                    ...state
                }
            }

            return {
                ...state,
                data: {
                    ...state.data,
                    [message?.layer]: [...state.data[message?.layer], ...message?.events]
                }
            }
        }
        case 'destroy':
            return { ...state, starting: false }
        case 'span':
            return { ...state, span: { ...state.span, [message?.layer]: message.events } }
        case 'endHistory':
            return { ...state, endHistory: true, data: state.buffer, queryStarted: false, starting: false }
        default:
            break
    }

    return state
}

export default WidgetReducer
